import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTh } from '@fortawesome/free-solid-svg-icons'
import { NavDropdown } from 'react-bootstrap'
import React from 'react'


export default function AppsNav(props) {
  const catalogUri = `${process.env.REACT_APP_CATALOG_URI}`
  const directoryUri = `${process.env.REACT_APP_DIRECTORY_URI}`
  const vocabUri = `${process.env.REACT_APP_VOCAB_URI}`
  const sbLinksUrl = 'https://www.sciencebase.gov/catalog/nav/sbLinks'

  return (
    <NavDropdown alignRight id="sb-nav-apps" className="no-carrot" title={
      <FontAwesomeIcon icon={faTh} fixedWidth />
    }>
      <NavDropdown.Item title="ScienceBase Catalog" target="_blank" href={catalogUri}>
        ScienceBase Catalog
      </NavDropdown.Item>
      <NavDropdown.Item title="ScienceBase Directory" target="_blank" href={directoryUri}>
        ScienceBase Directory
      </NavDropdown.Item>
      <NavDropdown.Item title="ScienceBase Vocab" target="_blank" href={vocabUri}>
        ScienceBase Vocab
      </NavDropdown.Item>
      <NavDropdown.Item title="More ScienceBase powered sites" target="_blank" href={sbLinksUrl}>
        More ...
      </NavDropdown.Item>
    </NavDropdown>
  )
}